module.exports = __webpack_public_path__ + "img/game_2_.6940009c.png";